// Third party
import axios from 'axios';

// Components
import { getAuthHeaders } from '../utils';
import { DEV_APP_API_URL } from '../constants';

export function ActiveSessionsController() {
  const getActiveSessions = async <T>(): Promise<T> => {
    return await axios.get(`${DEV_APP_API_URL}/session/all-active`, {
      headers: getAuthHeaders(),
    });
  };

  const endActiveSession = async <T>(session_id: number): Promise<T> => {
    return await axios.post(`${DEV_APP_API_URL}/session/admin-end`, { session_id }, {
      headers: getAuthHeaders(),
    });
  };

  return { getActiveSessions, endActiveSession };
}
